import React, { createContext, useContext, useRef } from 'react';
import { Toast } from 'primereact/toast';

// Create a context to store the Toast reference
const ToastContext = createContext<{ toast: React.RefObject<Toast> | null }>({ toast: null });

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};

// Define the type of the ToastProvider props
interface ToastProviderProps {
  children: React.ReactNode;
}


// Define a provider to wrap your app
export const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
  const toastRef = useRef<Toast>(null);

  return (
    <ToastContext.Provider value={{ toast: toastRef }}>
      <Toast ref={toastRef} position="top-right" />
      {children}
    </ToastContext.Provider>
  );
};
